import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import Typography from "../Typography/Typography";

// @ts-ignore
import { usePickerAnimation } from "./usePickerAnimation";

const StyledWrapper = styled(Box)(() => {
  return {
    height: 70,
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    rowGap: 10,
  };
});

const StyledItem = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: 60,
    margin: 0,
    padding: 0,
    position: "relative",
    flexShrink: 0,
    cursor: "pointer",

    "&.wheel-pickier-item .wheel-pickier-item--content-wrap--label": {
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightRegular,
    },

    "&.wheel-pickier-item .wheel-pickier-item--content-wrap": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      columnGap: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightMedium,
      color: "#696969",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "transparent",
      margin: theme.spacing(0, 0.5),
      fontSize: "18px",
      lineHeight: "20px",
    },

    "&.wheel-pickier-item.wheel-pickier-item-active .wheel-pickier-item--content-wrap": {
      fontSize: "24px",
      color: theme.palette.primary.main,
      borderRadius: 100,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.success.main,
      backgroundColor: `${theme.palette.success.main} !important`,
    },
  };
});

// TODO remove
const values = [
  1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12,
];

export type PickerProps = {
  onChange?: (value: number) => void;
  selectedValue: number;
};

const Picker: FC<PickerProps> = ({ onChange, selectedValue }) => {
  const [value, setValue] = useState<number>(selectedValue || values[0]);
  const { container } = usePickerAnimation(
    (index: number) => setValue(values[index]),
    values.indexOf(value),
  );

  useEffect(() => {
    onChange?.(value);
  }, [onChange, value]);

  return (
    <Box my={2.5} ref={container}>
      <Typography textTransform="uppercase" variant="body1" color="primary" mb={1.25}>
        Кількість годин
      </Typography>
      <StyledWrapper>
        {values.map((el) => (
          <StyledItem
            key={el}
            className={`wheel-pickier-item ${el === value && "wheel-pickier-item-active"}`}
          >
            <Box className="wheel-pickier-item--content-wrap">
              <Box component="span">{el}</Box>
              <Box component="span" className="wheel-pickier-item--content-wrap--label">
                Год
              </Box>
            </Box>
          </StyledItem>
        ))}
      </StyledWrapper>
    </Box>
  );
};

export default Picker;
